@if (step === Step.Flow) {
  <rt-requisitions-approval-request-flow-preview
    [adminsMap]="adminsMap"
    [flow]="flow"
    [departmentName]="departmentName"
    [isDepartmentsMode]="isDepartmentsMode"
    (continue)="changeStep(Step.Message)"
    (cancel)="cancel()"
  />
}
@if (step === Step.Message) {
  <rt-requisitions-approval-request-message
    [approvers]="approvers"
    [submitting]="submitting"
    [attachments]="attachments"
    [attachmentsUploading]="attachmentsUploading"
    [message]="message"
    (goBack)="changeStep(Step.Flow)"
    (submit)="submit($event)"
    (cancel)="cancel()"
    (uploadAttachmentClick)="uploadAttachment($event)"
    (deleteAttachmentClick)="deleteAttachment($event)"
  />
}
